import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import { useFormContext } from "react-hook-form";
import { type IRecurringOption, recurringOptions } from "./schedulingModels";
import { recurringDictionary } from "./schedulingModels";
import { useLingui } from "@lingui/react/macro";

export type IRecurrencePickerFields = {
  recurrence: IRecurringOption | null;
};

export const RecurrencePicker = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<IRecurrencePickerFields>();

  return (
    <RadioButtons
      errorMessage={errors.recurrence?.message}
      orientation="horizontal"
      legend={t`Upprepning`}
    >
      {recurringOptions.map((option) => (
        <RadioButton
          key={option}
          label={{ text: t(recurringDictionary[option]) }}
          {...register("recurrence", {
            required: {
              value: true,
              message: t`Sätt upprepningsmönster`,
            },
          })}
          value={option}
          visualStyle="framed"
        />
      ))}
    </RadioButtons>
  );
};
